(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.PopulationDialog = (function(superClass) {
    extend(PopulationDialog, superClass);

    function PopulationDialog() {
      return PopulationDialog.__super__.constructor.apply(this, arguments);
    }

    PopulationDialog.prototype.init = function() {
      this.layoutUrl = 'backend/portal/weightings/population/load-layout';
      this.saveUrl = 'backend/portal/weightings/population/save';
      return this.createDialog();
    };

    PopulationDialog.prototype.afterLoadLayout = function(selector, response) {
      var ref, self;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        this.openDialog();
        return;
      }
      self = this;
      this.dialog.find('input[type="checkbox"]').bind('change', function() {
        var inputs;
        inputs = $(this).closest('.component-container').find('select');
        if ($(this).is(':checked')) {
          return inputs.removeAttr('disabled');
        } else {
          return inputs.attr('disabled', 'disabled');
        }
      });
      this.dialog.find('input[type="checkbox"]').trigger('change');
      this.dialog.find('.cancel-btn').removeAttr('data-dismiss').bind('click', (function(_this) {
        return function() {
          return _this.refresh();
        };
      })(this));
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.save('Saving population components...');
        };
      })(this));
      if (/iPad/i.test(navigator.userAgent)) {
        this.dialog.find('.info-popover').clickover({
          html: true,
          container: '#bs2-container'
        });
      } else {
        this.dialog.find('.info-popover').clickover({
          html: true,
          container: '#bs2-container',
          trigger: 'hover'
        });
      }
      return this.openDialog();
    };

    return PopulationDialog;

  })(FullPageHandler);

}).call(this);
